/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sch_Level_3_HintInputs */

const en_sch_level_3_hint = /** @type {(inputs: Sch_Level_3_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The top of the hierarchy. Groups epics and other work and has no parent.`)
};

const de_sch_level_3_hint = /** @type {(inputs: Sch_Level_3_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Spitze der Hierarchie. Bündelt Epics und andere Arbeit und hat keinen übergeordneten Vorgang.`)
};

/**
* | output |
* | --- |
* | "The top of the hierarchy. Groups epics and other work and has no parent." |
*
* @param {Sch_Level_3_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_level_3_hint = /** @type {((inputs?: Sch_Level_3_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Level_3_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_level_3_hint(inputs)
	return en_sch_level_3_hint(inputs)
});